import axios from "axios";
import { message } from "antd";
import moment from "moment";

function nombreDesdeContentDisposition(headerValue) {
  const match = /filename="?([^"]+)"?/.exec(headerValue || "");
  return match ? match[1] : null;
}

async function exportarExcelReporte({
  empresaId,
  modeloKey,
  camposSeleccionados,
  filtros,
  nivelDetalle,
  plantillaId,
  headersToken,
}) {
  try {
    const res = await axios.post(
      "creadorDeReportes/exportarExcel",
      { empresaId, modeloKey, camposSeleccionados, filtros, nivelDetalle, plantillaId },
      { headers: headersToken, responseType: "blob" }
    );

    const esExcel = res.headers["content-type"]?.includes("spreadsheetml");
    if (!esExcel) {
      const texto = await res.data.text();
      const cuerpo = JSON.parse(texto);
      return message.error(cuerpo.message || "No se pudo exportar el reporte");
    }

    if (res.headers["x-reporte-truncado"] === "true") {
      message.warning("El reporte tiene más filas de las exportadas: aplica más filtros para verlas todas.");
    }

    const nombreBase = (nombreDesdeContentDisposition(res.headers["content-disposition"]) || "Reporte.xlsx").replace(
      /\.xlsx$/i,
      ""
    );
    const nombreArchivo = `${nombreBase}_${moment().format("DD-MM-YYYY")}.xlsx`;

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    message.error("No se pudo exportar el reporte");
  }
}

export default exportarExcelReporte;
